module.exports = __webpack_public_path__ + "img/zhuan.737dc99b.png";